import { Box, SystemIcon, Typography } from '@wishket/design-system';

import { Illust } from '@/shared/Components';

const AskAIRestartCard = () => {
  return (
    <Box className="flex flex-col gap-7 desktop:gap-4">
      <Box className="flex size-8 shrink-0 items-center justify-center rounded-full bg-gradient-primary-0 desktop:size-10">
        <SystemIcon
          name="medium_answer"
          className="text-w-white desktop:hidden"
        />
        <SystemIcon
          name="large_answer"
          className="hidden text-w-white desktop:block"
        />
      </Box>
      <Box className="flex flex-col items-center gap-12">
        <Box className="flex flex-col items-center gap-1.5">
          <Typography
            variant="subTitle2"
            className="desktop:subTitle1 font-medium text-w-gray-900"
          >
            질문한 내용을 이해하기가 어려워요.
          </Typography>
          <Typography
            variant="body1"
            className="whitespace-pre-line text-center text-w-gray-400 desktop:whitespace-normal"
          >
            {`문구를 바꾸거나 자세한 내용을 \n다시 질문해 주세요.`}
          </Typography>
        </Box>
        <Illust name="yogo_cat_restart" />
      </Box>
    </Box>
  );
};

export default AskAIRestartCard;
